module.exports = __webpack_public_path__ + "img/air.15a130e6.png";